import { UI_PRIMITIVE__checkbox } from '@/components/ui/UI_PRIMITIVE__checkbox';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_user } from '@/hooks/store/use_slices';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { REMOTE__user_settings_update } from '@/state/user/settings/REMOTE__user_settings_update';
import { assert_type_boolean } from '@shared/asserts/utils_asserts';
import { DTO__user_settings } from '@shared/dto/+user/user_settings/DTO__user_settings';
import { useTranslation } from 'react-i18next';

interface Props {
  settingKey: keyof DTO__user_settings;
  i18nKey: string;
  disabled?: boolean;
}

export function CheckboxSettingUser({ settingKey, i18nKey, disabled }: Props) {
  const dispatch = use_dispatch();
  const { user_settings } = use_slice_user(['user_settings']);
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_USER);

  assert_type_boolean(user_settings[settingKey], { settingKey });

  /*
   * EVENTS
   */
  async function onClicked() {
    const settingsNew = user_settings.clone({ [settingKey]: !user_settings[settingKey] });

    await dispatch(REMOTE__user_settings_update(settingsNew));
  }

  /*
   * HTML
   */
  return (
    <div className="flex items-center mt-2">
      <UI_PRIMITIVE__checkbox id={settingKey} checked={user_settings[settingKey] as boolean} onCheckedChange={() => onClicked()} disabled={disabled} />
      <label htmlFor={settingKey} className={`ml-2 text-sm ${disabled ? 'opacity-50 pointer-events-none' : 'cursor-pointer'}`}>
        {t(i18nKey)}
      </label>
    </div>
  );
}
